import addressTranslations from "./addressTranslations";
import organizationTranslation from "./organizationTranslation";

const opposingPartyLegalEntityTranslations = {
  legalForm: {
    label: "Gesellschaftsform",
  },
 ...organizationTranslation,
  address: addressTranslations,
};
export default opposingPartyLegalEntityTranslations;
